import { StriimTooltip } from "@striim/striim-ui-v2";

const WithTooltip = (Component, tooltipContent, interactive = false, placement = "bottom") => {
    // If tooltip is empty, Don't add tooltip
    if (tooltipContent) {
        return (
            <StriimTooltip
                id="striim-tooltip"
                PopperProps={{ "data-test-id": "striim-tooltip" }}
                title={tooltipContent}
                interactive={interactive}
                placement={placement}
            >
                <div>{Component}</div>
            </StriimTooltip>
        );
    } else return Component;
};

export default WithTooltip;
